<div class="datatable-page-header">
  <h1>
    <span trans>Biolinks</span>
    <info-popover>
      <div class="title" trans>Link in Bio</div>
      <div trans>Offer multiple choices to your followers when they click on your Biolink. Share all your Social Media profiles, videos, songs, articles and other important links with just one url.</div>
    </info-popover>
  </h1>

  <div class="header">
    <datatable-filters pluralName="biolinks" [filters]="filters"></datatable-filters>
    <div class="action-buttons">
      <permission-aware-button permission="biolinks.create">
        <button
          mat-raised-button
          color="accent"
          class="button-with-icon"
          (click)="openCreateBiolinkModal()"
          trans
        >
          <mat-icon svgIcon="add"></mat-icon>
          <span trans>Add New Biolink</span>
        </button>
      </permission-aware-button>
    </div>
  </div>
</div>

<div class="datatable responsive-table">
  <mat-progress-bar
    class="loading-bar"
    mode="indeterminate"
    color="accent"
    *ngIf="datatable.paginator && datatable.paginator.loading$ | async"
  ></mat-progress-bar>
  <table class="material-table">
    <thead>
    <tr>
      <th table-header-checkbox></th>
      <th table-sort-header trans>Name</th>
      <th *ngIf="showUserColumn()" table-sort-header="user_id" trans>Owner</th>
      <th table-sort-header="links_count" trans>Links</th>
      <th table-sort-header="public" trans>Public</th>
      <th table-sort-header="rotator" trans>Rotator</th>
      <th table-sort-header="updated_at" trans>Last Updated</th>
      <th></th>
    </tr>
    <tr *ngIf="datatable.selectedRows$.value.length as selectedCount">
      <th colspan="6">
        <div
          class="bulk-actions-title"
          [transValues]="{count: selectedCount, resource: 'biolink(s)'}"
          trans
        >
          :count :resource selected:
        </div>
        <div class="bulk-actions">
          <permission-aware-button permission="biolinks.delete">
            <button
              type="button"
              mat-raised-button
              color="warn"
              (click)="maybeDeleteSelectedBiolinks()"
              trans
            >
              Delete
            </button>
          </permission-aware-button>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let biolink of biolinks$ | async">
      <td [table-body-checkbox]="biolink.id"></td>
      <td data-label="Name">
        <a class="link-group-name" [routerLink]="['/', biolink.hash]" target="_blank">{{
          biolink.name
          }}</a>
      </td>
      <td data-label="Owner" *ngIf="showUserColumn()">
        <user-column [user]="biolink.user"></user-column>
      </td>
      <td data-label="Link Count">{{ biolink.links_count }}</td>
      <td data-label="Public">
        <mat-icon svgIcon="check" *ngIf="biolink.active"></mat-icon>
        <span *ngIf="!biolink.active">-</span>
      </td>
      <td data-label="Rotator">
        <mat-icon svgIcon="check" *ngIf="biolink.rotator"></mat-icon>
        <span *ngIf="!biolink.rotator">-</span>
      </td>
      <td data-label="Last Updated">{{ biolink.updated_at | formattedDate }}</td>
      <td class="edit-column">
        <button
          type="button"
          mat-icon-button
          [routerLink]="[biolink.id, 'analytics']"
          [matTooltip]="'Analytics' | trans"
        >
          <mat-icon svgIcon="bar-chart"></mat-icon>
        </button>
        <permission-aware-button
          permission="biolinks.update"
          [userOwnsResource]="currentUser.get('id') === biolink.user_id"
        >
          <button
            [routerLink]="[biolink.id, 'edit']"
            mat-icon-button
            [matTooltip]="'Edit' | trans"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
        </permission-aware-button>
        <copy-link-btn [model]="biolink"></copy-link-btn>
        <permission-aware-button permission="biolinks.delete" class="visible-on-mobile">
          <button
            type="button"
            mat-icon-button
            (click)="maybeDeleteSelectedBiolinks([biolink.id])"
            trans
          >
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        </permission-aware-button>
      </td>
    </tr>
    </tbody>
  </table>
  <no-results-message svgImage="marketing.svg" *ngIf="datatable.paginator.noResults$ | async">
    <span primary-text trans>No biolinks have been created yet</span>
  </no-results-message>
  <datatable-footer></datatable-footer>
</div>
